/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import React from 'react';
import LayoutPage from '@pages/AppPage';
import * as Sentry from '@sentry/react';
import SentryErrorPage from './pages/SentryErrorPage';
import { RequireAuth } from './provider/auth';
import { AppProvider } from './provider/app';

export default function AuthApp() {
  return (
    <Sentry.ErrorBoundary
      fallback={SentryErrorPage}
      showDialog
      onError={(error) => {
        Sentry.captureException(error);
      }}
    >
      <RequireAuth>
        <AppProvider>
          <LayoutPage />
        </AppProvider>
      </RequireAuth>
    </Sentry.ErrorBoundary>
  );
}
